import {REQUEST_ADMIN_SALES, RECEIVE_ADMIN_SALES, REQUEST_ADMIN_SALES_DATES, RECEIVE_ADMIN_SALES_DATES} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function salesReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_ADMIN_SALES:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_ADMIN_SALES:
      return objectAssign({}, state, {
        sales: action.items,
        isFetching: false
      });

    case REQUEST_ADMIN_SALES_DATES:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_ADMIN_SALES_DATES:
      return objectAssign({}, state, {
        salesDates: action.dates,
        isFetching: false
      });

    default:
      return state;
  }
}
